<div class="datetime-range-input">
  <div nimbusMaterialButtonsRow class="quick-actions">
    @for (quickAction of quickActions; track quickAction) {
      @if (!isQuickActionSelected(quickAction)) {
        <button nimbusSecondaryButton (click)="onQuickActionClick(quickAction)">
          {{ quickAction.label }}
        </button>
      } @else {
        <button nimbusPrimaryButton (click)="onQuickActionClick(quickAction)">{{ quickAction.label }}</button>
      }
    }
  </div>
  <div [formGroup]="form" class="manual-inputs">
    <div class="manual-inputs-row">
      <mat-form-field>
        <mat-label>{{ TranslationKeys.GeneralStartTime | translate }}</mat-label>
        <nimbus-filter-time-range-input
          [timeFormat]="timeFormat"
          [locale]="locale"
          [placeholder]="TranslationKeys.GeneralStartTime | translate"
          formControlName="startTime"
        ></nimbus-filter-time-range-input>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ TranslationKeys.GeneralStartDate | translate }}</mat-label>
        <nimbus-filter-date-range-input
          [placeholder]="TranslationKeys.GeneralStartDate | translate"
          formControlName="start"
          [dateFormat]="selectedDateFormat$ | async"
        ></nimbus-filter-date-range-input>
      </mat-form-field>
    </div>
    <div class="manual-inputs-row">
      <mat-form-field>
        <mat-label>{{ TranslationKeys.GeneralEndTime | translate }}</mat-label>
        <nimbus-filter-time-range-input
          [timeFormat]="timeFormat"
          [locale]="locale"
          [placeholder]="TranslationKeys.GeneralEndTime | translate"
          formControlName="endTime"
        ></nimbus-filter-time-range-input>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ TranslationKeys.GeneralEndDate | translate }}</mat-label>
        <nimbus-filter-date-range-input
          [placeholder]="TranslationKeys.GeneralEndDate | translate"
          formControlName="end"
          [dateFormat]="selectedDateFormat$ | async"
        ></nimbus-filter-date-range-input>
      </mat-form-field>
    </div>
  </div>
  <div class="calendar">
    <mat-calendar
      [minDate]="minDate"
      [maxDate]="maxDate"
      [selected]="selectedDateRange"
      [headerComponent]="header"
      (selectedChange)="onSelectedChanged($event)"
    ></mat-calendar>
  </div>
</div>
